import * as actions from "./funnel.actions";
import * as selectors from "./funnel.selectors";

export { actions, selectors };